<template>
    <el-popover :placement="placement" trigger="hover">
        <el-table
            :data="exportList"
            border
            max-height="500"
            v-loading="loading"
            :element-loading-text="loadingText"
            :size="size"
        >
            <el-table-column label="名称" width="400">
                <template slot-scope="scoped">
                    <div v-if="scoped.row['edit']" class="flex-row">
                        <el-input :size="size" v-model="scoped.row[name]"/>
                        <el-button class="ML20" :size="size" type="primary" plain @click="exportUpd(scoped)">保存</el-button>
                    </div>
                    <span v-else>{{ scoped.row[name] }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" :prop="createTime" width="200"/>
            <el-table-column label="操作" align="center" width="200">
                <template slot-scope="scoped">
                    <el-button type="success" :size="size" icon="el-icon-download" circle @click="exportDownload(scoped.row)"/>
                    <el-button
                        v-if="updBtn"
                        type="primary"
                        :size="size"
                        icon="el-icon-edit-outline"
                        circle
                        @click="exportUpdOpen(scoped)"
                    />
                    <el-button v-if="delBtn" type="danger" :size="size" icon="el-icon-delete" circle @click="exportDel(scoped)"/>
                </template>
            </el-table-column>
        </el-table>
        <el-button :size="btnSize" type="primary" slot="reference" @click="setExport">导出</el-button>
    </el-popover>
</template>

<script>
import {type} from "otb-module/src/utils/tool";

export default {
    name: "hExport",
    props: {
        loading: {
            type: Boolean,
            default: () => {
                return false
            },
        },
        size: {
            type: String,
            default: "mini"
        },
        btnSize: {
            type: String,
            default: "small"
        },
        placement: {
            type: String,
            default: "bottom-end"
        },
        exportList: {
            type: Array,
            default: () => {
                return [];
            },
        },
        prop: {
            type: Object,
            default: () => {
                return {}
            },
        }
    },
    data() {
        return {
            name: "name",
            createTime: "created_at",
            updBtn: true,
            delBtn: true,
            loadingText: "努力加载中..."
        };
    },
    watch: {
        prop: {
            handler(newVal) {
                if (newVal.name) this.name = newVal.name;
                if (newVal.createTime) this.createTime = newVal.createTime;
                if (type(newVal.updBtn) === "Boolean") this.updBtn = newVal.updBtn;
                if (type(newVal.delBtn) === "Boolean") this.delBtn = newVal.delBtn;
                if (newVal.loadingText) this.loadingText = newVal.loadingText;
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        setExport() {
            this.$emit("setExport");
        },
        exportDownload(row) {
            window.open(row.url + `?attname=${row[this.name]}`);
        },
        exportUpdOpen(e) {
            this.$set(this.exportList[e.$index], "edit", !e.row["edit"]);
        },
        exportUpd(e) {
            this.$emit("exportUpd", e);
        },
        exportDel(e) {
            this.$emit("exportDel", e);
        },
    }
}
</script>
